import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

interface Item {
  active: boolean,
  header: string,
  data: string,
}

@Component({
    selector: 'kaz-collapse',
    templateUrl: './kaz-collapse.component.html',
    styleUrls: ['./kaz-collapse.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FaIconComponent]
})
export class KazCollapseComponent {
  @Input() item: Item | null = null;

  constructor() {
  }
}
